import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function getRouterBasename(basePath: string) {
  if (!basePath || basePath === "." || basePath === "./") {
    return "/";
  }

  let normalized = basePath.trim();

  if (/^https?:\/\//i.test(normalized)) {
    normalized = new URL(normalized).pathname;
  }

  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  normalized = normalized.replace(/\/+$/, "");
  return normalized || "/";
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={getRouterBasename(__BASE_PATH__)}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
